import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./check.svg"; export default path + "#$"